module.exports = __webpack_public_path__ + "img/platform_gz3.663c74e9.png";